import {Injectable, TemplateRef} from '@angular/core';
import {
  IPpProductWizardDetailsData,
  IPpProductWizardOverviewData,
  IPpProductWizardProvider
}                                from '../pp-product-wizard.types';
import {BehaviorSubject}         from 'rxjs';
import {
  ApDynformsConfigFieldset
}                                from '../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  LanguageStore
}                                from '../../../../stores/translation/language.store';
import {
  PpProductWizardOverviewUiProvider
}                                from './pp-product-wizard-overview.ui-provider';
import {
  LoginStore
}                                from '../../../../stores/login/login.store';
import moment               from 'moment';
import {
  WorkTypesStore
}                                from '../../../../stores/base-data/worrktypes.store';
import {
  ApTranslationService
}                                from '../../../../ap-utils/service/ap-translation.service';

/**
 * PP-product wizard overview-tab business logic provider
 */
@Injectable()
export class PpProductWizardOverviewProvider implements IPpProductWizardProvider {
  private _caption$: BehaviorSubject<string>;
  private _fieldSets$: BehaviorSubject<ApDynformsConfigFieldset[]>;
  private _ppProductSelectedDetailsTemplate: TemplateRef<any>;

  constructor(private languageStore: LanguageStore,
              private translationService: ApTranslationService,
              private loginStore: LoginStore,
              private workTypesStore: WorkTypesStore) {
  }

  public init(caption$: BehaviorSubject<string>,
              fieldSets$: BehaviorSubject<ApDynformsConfigFieldset[]>,
              ppProductSelectedDetailsTemplate: TemplateRef<any>): void {
    this._caption$ = caption$;
    this._fieldSets$ = fieldSets$;
    this._ppProductSelectedDetailsTemplate = ppProductSelectedDetailsTemplate;
  }


  public updateCaption(): void {
    this._caption$?.next('Create_pp_product_overview');
  }

  public updateFieldSets(overviewData: IPpProductWizardOverviewData): void {
    this._fieldSets$?.next(PpProductWizardOverviewUiProvider
      .CreateFieldset(overviewData, this.loginStore,
        this._ppProductSelectedDetailsTemplate));
  }

  /**
   * Creates a new instance of our overview item based on the entered product details
   */
  public buildOverviewItem(detailsData: IPpProductWizardDetailsData): IPpProductWizardOverviewData {
    return {
      ProductName: this.getProductExpr(detailsData),
      PermissionStartExpr: moment(detailsData?.PermissionStart)?.format(this.languageStore?.CurrentDateFormat),
      PermissionEndExpr: moment(detailsData?.PermissionEnd)?.format(this.languageStore?.CurrentDateFormat),
      UseByDateExpr: moment(detailsData?.UseByDate)?.format(this.languageStore?.CurrentDateFormat),
      WorkTypeExpr: this.translationService.translate(
        this.workTypesStore.WorkTypes?.FirstOrDefault(w => w?.Id === detailsData?.WorkType)?.Description),
      CountryExpr: detailsData?.Country?.length > 0 ? detailsData.Country : '-'
    };
  }

  /**
   * Method to builds product expression (optional truncated) productName and note
   */
  private getProductExpr(detailsData: IPpProductWizardDetailsData): string {
    if (!detailsData || detailsData?.ProductName?.length <= 0) {
      return '-';
    }
    let productExpr = detailsData.ProductName?.length > 70 ? `${detailsData.ProductName?.slice(0, 70)}...` : detailsData.ProductName;
    if (detailsData.Note?.length > 0) {
      const note = detailsData.Note?.length > 70 ? `${detailsData.Note?.slice(0, 70)}...` : detailsData.Note;
      productExpr += ` (${note})`;
    }
    return productExpr;
  }

  /**
   * Custom height calculation for the pp-product wizard overview tab
   */
  public getSelectedDetailsGridHeight(): string {
    return 'calc(100vH - 330px)';
  }

  /**
   * Cleanup the mess...
   */
  public onDestroy(): void {
  }
}
